/**
 * Type-ahead suggestions. These are conveniences, not restrictions — the
 * SearchSelect that consumes them accepts anything typed.
 *
 * Aligned with the LancersTech Pakistan localization (Lahore default, Pakistani context).
 */
export const CITIES = [
  'Lahore', 'Karachi', 'Islamabad', 'Rawalpindi', 'Faisalabad', 'Peshawar',
  'Multan', 'Gujranwala', 'Quetta', 'Sialkot', 'Hyderabad', 'Bahawalpur',
  'Sargodha', 'Sukkur', 'Abbottabad', 'Mirpur', 'Gilgit', 'Gwadar', 'Other',
];

export const NATIONALITIES = [
  'Pakistani', 'Other', 'Overseas Pakistani', 'British', 'American', 'Canadian',
  'Australian', 'Turkish', 'Emirati', 'Saudi Arabian', 'Malaysian'
];

export const RELATIONS = [
  'Mother', 'Father', 'Brother', 'Sister', 'Guardian', 'Spouse',
  'Uncle', 'Aunt', 'Cousin', 'Friend', 'Other',
];
